import { useEffect, useState, useCallback } from "react";
import { yetkiProfilim } from "./api";
import { useAuth } from "./auth";

const cache = { loaded: false, data: null };

export function usePermissions() {
    const { user } = useAuth();
    const [izinler, setIzinler] = useState(cache.data?.izinler || {});
    const [superuser, setSuperuser] = useState(cache.data?.superuser ?? true);
    const [loading, setLoading] = useState(!cache.loaded);

    useEffect(() => {
        if (!user) return;
        let cancelled = false;
        yetkiProfilim()
            .then((d) => {
                if (cancelled) return;
                cache.loaded = true;
                cache.data = d;
                setIzinler(d.izinler || {});
                setSuperuser(!!d.superuser);
            })
            .catch(() => {
                if (!cancelled) {
                    setSuperuser(true);
                    setIzinler({});
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [user]);

    const can = useCallback(
        (module, action = "read") => {
            if (superuser) return true;
            const mod = izinler[module] || {};
            if (action === "read") return !!mod.read;
            if (action === "write") return !!mod.write;
            if (action === "delete") return !!mod.delete;
            return false;
        },
        [izinler, superuser],
    );

    return { can, izinler, superuser, loading };
}
